import CustomButton from "../../components/CustomButton";
import { useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "../../store";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  clearSearchFilters,
  setPagination,
  setSearchFilters,
} from "../../features/student/StudentSlice";
import AcademicCycleSelect from "../../components/common-input/AcademicCycle";
import ClassSelect from "../../components/common-input/ClassSelect";
import { IS_LIVE } from "../../util/config/env";
import { useEffect } from "react";

export default function StudentsHeader() {
  const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();

  const { searchFilters } = useSelector((state: RootState) => state.student);

  const handleFilterChange = (name: string, value: string) => {
    dispatch(setSearchFilters({ [name]: value }));

    dispatch(setPagination({ currentPage: 0, pageSize: 10 }));
  };

  useEffect(() => {
    return () => {
      dispatch(clearSearchFilters());
    };
  }, []);

  return (
    <div className="flex flex-col-reverse lg:flex-row lg:justify-between gap-5">
      <div className="grid grid-cols-2 justify-items-end gap-3 ">
        <ClassSelect
          name="classId"
          value={searchFilters.classId}
          includeAll
          placeholder="Filter by class name..."
          onChange={(e) => handleFilterChange("classId", e.target.value)}
          selectClassName="border-none bg-white"
        />
        <AcademicCycleSelect
          name="academicCycleId"
          value={searchFilters.academicCycleId}
          placeholder="Filter by Academic Cycle..."
          includeAll
          onChange={(e) =>
            handleFilterChange("academicCycleId", e.target.value)
          }
          selectClassName="border-none bg-white"
        />
      </div>

      <div className="flex justify-end items-end flex-row gap-3 w-full lg:w-auto">
        {!IS_LIVE && (
          <CustomButton
            text="Import"
            color="bg-success-500"
            onClick={() => navigate("/all-students/student-data-import")}
          />
        )}
        <CustomButton
          text="Add Student"
          color="bg-primary-500"
          onClick={() => navigate("/all-students/add-student")}
        />
      </div>
    </div>
  );
}
